/** Frame-rate-independent text reveal, with separate reveal/continue taps. */
export class DialoguePlayback {
  private characters: string[] = [];
  private revealed = 0;
  private readyMs = 0;
  active = false;

  start(text: string): void {
    this.characters = Array.from(text);
    this.revealed = 0;
    this.readyMs = 0;
    this.active = true;
  }

  get typing(): boolean {
    return this.active && this.revealed < this.characters.length;
  }

  get text(): string {
    return this.characters.slice(0, Math.floor(this.revealed)).join('');
  }

  update(deltaMs: number): void {
    if (!this.active) return;
    if (this.typing) {
      this.revealed = Math.min(
        this.characters.length,
        this.revealed + Math.max(0, deltaMs) * 0.032,
      );
    } else {
      this.readyMs += Math.max(0, deltaMs);
    }
  }

  /** First tap reveals, a later tap acknowledges the line. */
  advance(): boolean {
    if (!this.active) return false;
    if (this.typing) {
      this.revealed = this.characters.length;
      this.readyMs = 0;
      return false;
    }
    if (this.readyMs < 250) return false;
    this.active = false;
    return true;
  }

  cancel(): void {
    this.active = false;
  }
}
